  var inputField = document.querySelector('input[name="ch-order-search"]');
  console.log(inputField, "inputField");
  if (inputField) {
    inputField.setAttribute("autocomplete", "off");
  }

  var myForm = document.createElement("form");
  if (myForm) {
      myForm.setAttribute("autocomplete", "off");
      myForm.style.width = "100%";
  }

  if (inputField && myForm) {
    inputField.parentNode.replaceChild(myForm, inputField);
    var newInput = document.createElement("input");
    if (newInput) {
      newInput.type = "text";
      newInput.id = "cho-search";
      newInput.name = "cho-order-search";
      newInput.autocomplete = "off";
      newInput.placeholder = "Search By Product Name or Order Number";
    }
    myForm.appendChild(newInput);
  }
